<template>
  <div>
    <b-modal
      v-model="showSidebar"
      title="Хандалтын лог"
      hide-footer
      @hide="$emit('on-hide')"
    >
      <div class="pd-20">
        <DatePicker
          v-model="mdlCourseStartDate"
          placeholder="Эхлэх огноо сонгоно уу"
          type="datetime"
          style="width: 100%"
          :format="'yyyy-MM-dd HH:mm:ss'"
          :value-format="'yyyy-MM-dd HH:mm:ss'"
        ></DatePicker>
      </div>
      <div class="pd-20">
        <DatePicker
          v-model="mdlCourseEndDate"
          placeholder="Дуусах огноо сонгоно уу"
          type="datetime"
          style="width: 100%"
          :format="'yyyy-MM-dd HH:mm:ss'"
          :value-format="'yyyy-MM-dd HH:mm:ss'"
        ></DatePicker>
      </div>
      <div class="pd-20">
        <Checkbox v-model="mdlCourseGroupBy"
          >Хэрэглэгчийн давхцал арилгах</Checkbox
        >
      </div>
      <div class="text-center pd-t-20">
        <button class="btn btn-primary" @click="downloadCourseLog()">
          Дэлгэрэнгүй
        </button>
        <!-- <Button long  type="primary">Дэлгэрэнгүй</Button> -->
      </div>
    </b-modal>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import { DatePicker, Checkbox } from "element-ui";
import { request } from "@/api/all";

export default {
  components: {
    DatePicker,
    Checkbox
  },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    id: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      showSidebar: false,
      mdlCourseStartDate: null,
      mdlCourseEndDate: null,
      mdlCourseGroupBy: false
    };
  },
  methods: {
    init() {
      this.showSidebar = true;
    },
    downloadCourseLog() {
      request({
        api: { method: "get", url: "task/taskViewLogExport" },
        params: {
          id: this.id,
          startDate: this.mdlCourseStartDate,
          endDate: this.mdlCourseEndDate,
          groupBy: this.mdlCourseGroupBy
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //this.mdlCourseLog = false;
          this.$emit("on-attach", res.data.file.id);
          this.$emit("on-hide");
          //this.visibleChanged(false);
        }
      });
    }
  },
  computed: {
    showModal() {
      return this.show;
    }
  },
  watch: {
    showModal(val) {
      if (val) {
        this.init();
      } else {
        this.showSidebar = false;
      }
    }
  }
};
</script>
